module.exports = __webpack_public_path__ + "static/media/download-cxm-app2.af2c9989.png";